<template>
  <!-- 电脑端-背景图（ABtest版） -->
  <img id="u_c_B0FU17" class="normal u_c_B0FU17" data-gtm="gtm-click-bg" alt="" :src="compData.curImageHref || compData.abTestList[compData.curImageIndex].bg" @click="u_c_B0FU17_event_KJ3R18($event)"/>
  </template>
<script>
import {reactive,provide,inject,onMounted,watch,ref,computed} from "vue";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash";

export default {
  name: '',
  components: {},
  setup(){
    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"abTestList":[{
        'name': 'bg_1',
        'probability': 100,
        'bg': 'https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/08/16602717427402.jpg'
    }],"curImageIndex":0,"curImageHref":``},"vi-VN":{"abTestList":[{
        'name': 'bg_1',
        'probability': 100,
        'bg': 'https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/10/16662596077068.png'
    }],"curImageIndex":0,"curImageHref":``}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['vi-VN']||{});

    const router = Router();

    // 自定义setup - 开始
    const gaClickUpload = inject("gaClickUpload",()=>{})

const curProbability = utils.randomNumber(0, 100);
    const curTest = () => {
      let total = 0;
      let index = -1;
      for (let i in compData.abTestList) {
        if (isNaN(compData.abTestList[i].probability)) continue;
        if (total + +compData.abTestList[i].probability >= curProbability) {
          index = i;
          break;
        } else {
          total += +compData.abTestList[i].probability;
        }
      }
      return ~index ? index : 0;
    };
compData.curImageIndex = curTest();
compData.curImageHref = compData.abTestList[compData.curImageIndex].bg;
pageData.abTestVersion = compData.abTestList[compData.curImageIndex].name;;
      // 背景图（ABtest版）的click事件
      const u_c_B0FU17_event_KJ3R18= async (e)=>{
        try {gaClickUpload('gtm-click-bg');} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束
    return {u_c_B0FU17_event_KJ3R18,pageData,routerData,compData,langData}
  }
}
</script>
<style lang="scss" scoped>
.default{.u_c_B0FU17.normal{position:relative;height:100.00vh;font-size:0;z-index:-1;}}.vi-VN{.u_c_B0FU17.normal{position:relative;height:100.00vh;font-size:0;z-index:-1;}}
</style>
